import { ActionTree, GetterTree, MutationTree } from 'vuex';
import { AugmentedActionContext, State } from 'store';

import { GameConfigObj } from 'types/gameSession';
import { Player } from 'types/player';

import { fetchGameSessionConfig } from 'api/gameSession.services';
import { listPlayerService } from 'api/auth.services';

// Declare the state
export type UIState = {
    isSideBarOpen: boolean;
    isGeneralLoaderOn: boolean;
    isHttpLoaderOn: boolean;
    gameInputConfig: GameConfigObj;
    playersInDomain: Player[];
}


export const initialState: UIState = {
    isSideBarOpen: false,
    isGeneralLoaderOn: true,
    isHttpLoaderOn: false,
    gameInputConfig: {},
    playersInDomain: [],
};

export enum UiMutationType {
    TOGGLE_GENERAL_LOADER = 'toggleGeneralLoader',
    TOGGLE_HTTP_LOADER = 'toggleHttpLoader',
    CLOSE_SIDEBAR = 'closeSidebar',
    OPEN_SIDEBAR = 'openSidebar',
    SET_GAME_CONFIG = 'setGameConfig',
    SET_PLAYERS_IN_DOMAIN = 'setPlayersInDomain',
}


export type UiMutation<S = State> = {
    [UiMutationType.CLOSE_SIDEBAR](state: S, payload: {}): void;
    [UiMutationType.OPEN_SIDEBAR](state: S, payload: {}): void;
    [UiMutationType.TOGGLE_GENERAL_LOADER](state: S, payload: { value?: boolean }): void;
    [UiMutationType.TOGGLE_HTTP_LOADER](state: S, payload: { value?: boolean }): void;
    [UiMutationType.SET_GAME_CONFIG](state: S, payload: { gameConfig: GameConfigObj }): void;
    [UiMutationType.SET_PLAYERS_IN_DOMAIN](state: S, payload: { players: Player[] }): void;
}

export const UiMutations: MutationTree<State> & UiMutation = {
    [UiMutationType.CLOSE_SIDEBAR]({ ui }: State) {
        ui.isSideBarOpen = false
    }, [UiMutationType.OPEN_SIDEBAR]({ ui }: State) {
        ui.isSideBarOpen = true
    },
    [UiMutationType.TOGGLE_GENERAL_LOADER]({ ui }: State, payload: { value?: boolean }) {
        ui.isGeneralLoaderOn = payload.value !== undefined ? payload.value : !ui.isGeneralLoaderOn;
    },
    [UiMutationType.TOGGLE_HTTP_LOADER]({ ui }: State, payload: { value?: boolean }) {
        ui.isHttpLoaderOn = payload.value !== undefined ? payload.value : !ui.isHttpLoaderOn;
    },
    [UiMutationType.SET_GAME_CONFIG]({ ui }: State, payload: { gameConfig: GameConfigObj }) {
        ui.gameInputConfig = {};
        ui.gameInputConfig = { ...payload.gameConfig };
    },
    [UiMutationType.SET_PLAYERS_IN_DOMAIN]({ ui }: State, payload: { players: Player[] }) {
        ui.playersInDomain = [];
        ui.playersInDomain = [...payload.players];
    },
}


export enum UiActionTypes {
    TOGGLE_SIDEBAR = 'ui/toggleSidebar',
    INIT_UI_MODULE = 'ui/initUiModule'
}

export type UiActions = {
    [UiActionTypes.TOGGLE_SIDEBAR](
        { commit, getters }: AugmentedActionContext
    ): void;
    [UiActionTypes.INIT_UI_MODULE](
        { commit }: AugmentedActionContext
    ): void;
}

export const uiActions: ActionTree<State, State> & UiActions = {
    [UiActionTypes.TOGGLE_SIDEBAR]({ commit, getters }) {
        console.log(getters.isSidebarOpen, 'Store')
        if (getters.isSidebarOpen)
            return commit(UiMutationType.CLOSE_SIDEBAR, {})

        commit(UiMutationType.OPEN_SIDEBAR, {})
    },
    async [UiActionTypes.INIT_UI_MODULE]({ commit }) {
        await fetchGameSessionConfig().then((response) => {
            const { gameSessionConfigurationsMap } = response.data;

            commit(UiMutationType.SET_GAME_CONFIG, { gameConfig: gameSessionConfigurationsMap })

            return listPlayerService()
        }).then((response) => {
            const { data: { playersList } } = response;

            commit(UiMutationType.SET_PLAYERS_IN_DOMAIN, { players: playersList });

            commit(UiMutationType.TOGGLE_GENERAL_LOADER, { value: false })
        })
    },
};

export type UiGetters = {
    getPlayersInDomain({ ui }: State): Player[];
}

export const uiGetter: GetterTree<State, State> & UiGetters = {
    getPlayersInDomain: ({ ui }: State) => {
        return ui.playersInDomain
    }
};